<template>
	<div>
		<AppButton
			:label="$t('add')"
			startIcon="plus"
			@click="onAddRole"
		/>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useCreateRoleDialog } from '../../../stores/create-role-dialog';

const createRoleDialogStore = useCreateRoleDialog();

const onAddRole = () => {
	createRoleDialogStore.open();
};
</script> 